<template>
	<div id="wrapper">
		<SidebarView :sms="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<!-- begin row  -->
					<div class="row">
						<div class="col-lg-12">
							<div class="card card-shape home-box">
								<div class="card-header">
									<div class="d-flex justify-content-between align-items-center">
										<div>
											<h6 class="m-0 fw-bold text-green">All Sms</h6>
										</div>
										<div>
											<b-button v-b-modal.send-mail-all size='sm' class="akkurate-green-btn btn-size" variant="primary">
												<span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'mail-forward']" /> Send
													Sms</span>
											</b-button>
											<!-- <b-link title="Excel Export" @click="exportToExcel"
												class="fw-semibold ms-2 akkurate-green">
												<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>

											<b-link title="Bulk Mail" v-b-modal.send-mail-all
												class="fw-semibold ms-2 akkurate-green">
												<font-awesome-icon :icon="['fas', 'envelope']" /></b-link> -->
										</div>
									</div>
								</div>
								<div class="card-body px-0 pt-0">
									<div class="table_text_size">
										<b-table striped bordered responsive id="sms-table" :busy.sync="isBusy" :items="rows" :fields="fields" show-empty>

											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #empty="scope">
												<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
											</template>
											<template #cell(id)="data">
												{{ data.index + 1 }}
											</template>
											<template #cell(type)="data">
												<CustomTooltip :message="data.item.message" :color="'#ffffff'" :offsetY="30">
													{{ data.item.type }}
												</CustomTooltip>
											</template>
											<!-- A custom formatted column -->
											<template #cell(requested_by)="data">
												<CustomTooltip :message="data.item.message" :color="'#ffffff'" :offsetY="30">
													{{ data.item.requested_by?.first_name }} {{ data.item.requested_by?.surname }}
												</CustomTooltip>
											</template>
											<template #cell(created_at)="data">
												<div>
													{{ formatDateAndTime(data.item.created_at) }}
												</div>
											</template>
											<template #cell(approved_by)="data">
												<div>
													{{ data.item.approved_by?.first_name }}
													{{ data.item.approved_by?.surname }}
												</div>
											</template>
											<template #cell(date_sent)="data">
												<div>
													{{ formatDateAndTime(data.item.date_sent) }}
												</div>
											</template>
											<template #cell(status)="data">
												<CustomTooltip :message="data.item.message" :color="'#ffffff'" :offsetY="30">
													{{ data.item.status }}

												</CustomTooltip>
											</template>
											<template #cell(actions)="data">
												<span class="d-flex">
													<a title="Approve" v-if="data.item.status == 'pending'" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" variant="primary" @click="approveSms(data.item)">
														<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'check']" /></span>
													</a>
													<a title="Reject" v-if="data.item.status == 'pending'" class="btn btn-sm akkurate-danger-btn text-white border-0 custom-pointer" variant="primary" @click="rejectSms(data.item)">
														<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'close']" /></span>
													</a>
													<!-- <a title="Delete"
														class="btn btn-sm akkurate-danger-btn text-white border-0 custom-pointer"
														@click="deleteMember(data.item)" variant="primary">
														<span class="akkurate-small"> <i
																class="fas fa-trash"></i></span>
													</a> -->
												</span>
											</template>
										</b-table>

										<div class="d-flex justify-content-between px-3 pb-3">
											<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="member-table"></b-pagination>
											<div class="col text-end mt-1 akkurate-dark">
												<div>
													{{ currentPage }} -
													{{ perPage }} of
													{{ totalRecords }}
												</div>
												<b-form-group label="Per Page" label-size="sm" class="mb-0">
													<b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage" :options="per_page_options
														" size="sm"></b-form-select>
												</b-form-group>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- end row  -->

					<b-modal size="xxl" id="bv-modal-customer-view" hide-footer>
						<template #modal-title>
							<h6 class="m-0 fw-bold text-green text-sm">Member View</h6>
						</template>
						<member-view :id="member_id" :institution="institution"></member-view>
					</b-modal>


					<b-modal size="md" id="modal-member" @ok="handleOk">
						<template #modal-title>
							<h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
						</template>
						<!-- <member-filter :form="form" :filterTable="filterTable" :trans_source_options="trans_source_options" :users_options="users_options">
						</member-filter> -->
						<template #modal-footer="{ ok }">
							<div class="w-100">
								<!-- Emulate built in modal footer ok and cancel button actions -->
								<b-button @click="$bvModal.hide('modal-member')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
									</span></b-button>
								<b-button @click="ok()" type="submit" :disabled="isSearching" class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'search']" />Search</span></b-button>
							</div>
						</template>
					</b-modal>

					<send-sms-form :institution="institution"></send-sms-form>

				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>

</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import ApiService from "@/core/services/api.service";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import SendSmsForm from "./SendSmsForm.vue";

import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
// import MemberFilter from "../forms/MemberFilter.vue";
import MemberView from '@/views/main/pages/member/view/MemberView.vue'
import 'vue-good-table/dist/vue-good-table.css';
import Multiselect from 'vue-multiselect'
import CustomTooltip from "@/views/components/CustomTooltip.vue";
import { mapActions } from "vuex";
import { data } from "jquery";
import ChatBot from "@/views/components/AI/ChatBot.vue";
// import $ from 'jquery';
// import 'datatables.net';
// import config from '@/config.js'
// import JwtService from "@/core/services/jwt.service";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		MemberView,
		Multiselect,
		SendSmsForm,
		CustomTooltip,
		ChatBot,
	},
	computed: {
		// Count characters including spaces
		messageCharCount() {
			return this.sms_message ? this.sms_message.length : 0;
		},
		// Calculate how many SMS messages this will use (1 SMS = 160 chars)
		messageCount() {
			return Math.ceil(this.messageCharCount / 160) || 1;
		},
		// Calculate number of recipients (split by comma, trim, and filter out empty)
		recipientCount() {
			if (!this.recipient) return 0;
			return this.recipient
				.split(',')
				.map(num => num.trim())
				.filter(num => num.length > 0).length;
		},
	},

	data() {
		return {
			isSearching: false,
			showTooltip: false,
			status_option: ['Pending', 'Active', 'Inactive', "Dormant", "Closed"],
			trans_source_options: [
				{ name: 'USSD', value: "ussd" },
				{ name: 'OFFICE', value: "office" },
				{ name: 'MOBILE', value: "mobile" },
				// { name: 'Deposit', value: "deposit" },
				// { name: 'Withdrawal', value: "withdrawal" },
			],
			selected: 'custom',
			options: [
				{ text: 'Custom', value: 'custom' },
				{ text: 'Bulk', value: 'bulk' }
			],
			recipient: "",
			message: "",
			sms_message: "",
			users_options: [],
			member_id: "",
			institution: {},
			totalRecords: 0,
			searchFilter: "",
			isBusy: true,
			branch: null,
			branch_option: [],
			currentPage: 1,
			perPage: 10,
			per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
			per_page_selected: "10",
			disable_recipient: false,
			form: {
				status: "",
				search_term: "",
				from_date: "",
				to_date: "",
				trans_source: "",
				branch: "",
				start_date: "",
				end_date: "",
				gender: "",
				gender_option: ['Male', 'Female', 'Group'],
				users: []
			},
			fields: [
				{
					label: '#',
					key: 'id',
				},
				{
					label: 'Type',
					key: 'type',
				},
				{
					label: "Number of Receipts",
					key: "recipient_count"
				},
				{
					label: 'Requested By',
					key: 'requested_by',
				},
				{
					label: "Date Created",
					key: "created_at"
				},
				{
					label: "Approved By",
					key: "approved_by"
				},
				{
					label: "Date sent",
					key: "date_sent"
				},
				{
					label: 'Status',
					key: 'status',
				},
				{
					label: 'Actions',
					key: 'actions',
				},
			],
			rows: [],
		};
	},
	mounted() {
		let token = localStorage.getItem('token');
		if (!token) {
			this.$router.push({ path: '/login' });
		}

		this.loadItems();
		this.getInsistution();

	},
	methods: {
		onRadioChange(value) {
			// Do something when a radio is selected
			if (value == 'bulk') {
				this.disable_recipient = true;
				this.recipient = "";
			} else {
				this.disable_recipient = false;
			}
		},

		handleOk(bvModalEvent) {
			// Prevent modal from closing
			// bvModalEvent.preventDefault();
			// Trigger submit handler
			this.filterTable()
		},
		filterTable() {
			this.loadItems();
		},

		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems()
		},
		selectPerPage(index) {
			this.perPage = index
			this.loadItems()
		},
		showCustomerViewModal(id, institution) {
			this.member_id = id;
			this.institution = institution
			this.$bvModal.show('bv-modal-customer-view')
		},
		async sendSmsAll() {
			if (this.selected == 'bulk') {
				this.$Progress.start();
				this.isBusy = true;
				await ApiService.post(`/sms/request/all-customers`, {
					'message': this.sms_message,
				}).then((response) => {
					this.$Progress.finish();
					this.isBusy = false;
					swal.fire({
						// title: response.statusText,
						text: response.data?.message,
						icon: "success",
						allowOutsideClick: true,
						allowEscapeKey: true,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "okay", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
					this.loadItems();
				})
					.catch((error) => {
						this.$Progress.fail();
						this.isBusy = false;
						swal.fire({
							// title: response.statusText,
							text: error.response.data?.message,
							icon: "error",
							allowOutsideClick: true,
							allowEscapeKey: true,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "okay", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});
					}).finally(() => {
						this.$Progress.fail();
						this.isBusy = false;
					});

			} else {
				this.$Progress.start();
				this.isBusy = true;
				await ApiService.post(`/sms/request/multiple-phones`, {
					'recipients': this.recipient,
					'message': this.sms_message,
				}).then((response) => {
					this.$Progress.finish();
					this.isBusy = false;
					swal.fire({
						// title: response.statusText,
						text: response.data?.message,
						icon: "success",
						allowOutsideClick: true,
						allowEscapeKey: true,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "okay", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
					this.loadItems();
				})
					.catch((error) => {
						this.$Progress.fail();
						this.isBusy = false;
						swal.fire({
							// title: response.statusText,
							text: error.response.data?.message,
							icon: "error",
							allowOutsideClick: true,
							allowEscapeKey: true,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "okay", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});
					}).finally(() => {
						this.$Progress.fail();
						this.isBusy = false;
					});

			}

		},
		// load items is what brings back the rows from server
		async loadItems() {
			this.isBusy = true;
			this.$Progress.start();  // Start the progress bar
			// console.log(this.form.users);
			await ApiService.post("/sms/approvals/pending",
				{
					"page": this.currentPage,
					"per_page": this.perPage,
				}
			).then(response => {
				// Handle response and update table data
				this.isBusy = false;  // Set isBusy to false when the data is loaded
				// this.$Progress.finish();  // Finish the progress bar
				this.rows = response.data?.approvals;
				// this.totalRecords = response.data.meta.total;

			}).catch(() => {
				this.isBusy = false;  // Set isBusy to false in case of an error
				this.$Progress.finish();  // Finish the progress bar even if there's an error
				return [];  // Return an empty array in case of error to prevent the table from breaking
			}).finally(() => {
				this.isBusy = false;  // Set isBusy to false in case of an error
				this.$Progress.finish();  // Finish the progress bar even if there's an error
			});
		},
		approveSms(data) {
			swal.fire({
				title: "Approve Sms",
				html: `Are you sure you want to Approve Sms ?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Approve",
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
				// allowOutsideClick: false
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
					//send put request to reset password
					ApiService.post(`/sms/approvals/${data.id}/process`, {
						action: "approve", //approve,reject
					}).then((response) => {
						swal.fire({
							title: "Success",
							html: response.data.message,
							icon: "success",
							showCancelButton: false,
							confirmButtonColor: "#3085d6",
							cancelButtonColor: "#d33",
							confirmButtonText: "Ok",
							allowOutsideClick: false,
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});
						this.loadItems();
					})
						.catch((error) => {
							swal.fire({
								title: "Error",
								text: error.response.data.message,
								icon: "error",
								showCancelButton: false,
								confirmButtonColor: "#3085d6",
								cancelButtonColor: "#d33",
								confirmButtonText: "Ok",
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
								// allowOutsideClick: false
							});
						});
				}
			});
		},

		rejectSms(data) {
			swal.fire({
				title: "Reject Sms",
				html: `Are you sure you want to Reject Sms ?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Approve",
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
				// allowOutsideClick: false
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
					//send put request to reset password
					ApiService.post(`/sms/approvals/${data.id}/process`, {
						action: "reject", //approve,reject
					}).then((response) => {
						swal.fire({
							title: "Success",
							html: response.data.message,
							icon: "success",
							showCancelButton: false,
							confirmButtonColor: "#3085d6",
							cancelButtonColor: "#d33",
							confirmButtonText: "Ok",
							allowOutsideClick: false,
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});
						this.loadItems();
					})
						.catch((error) => {
							swal.fire({
								title: "Error",
								text: error.response.data.message,
								icon: "error",
								showCancelButton: false,
								confirmButtonColor: "#3085d6",
								cancelButtonColor: "#d33",
								confirmButtonText: "Ok",
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
								// allowOutsideClick: false
							});
						});
				}
			});
		},
		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
	},

};
</script>
